(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.cart__checkout-button');
      if (!button || button.disabled) return;
      event.preventDefault();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'pages/checkout';
    },
    true
  );
})();
